const setInventoryType = (type, toString) => {
  const values = {
    CO: [
      { num: [2], name: 'Externo' },
      { num: [1], name: 'Inmueble Habi' },
    ],
    MX: [
      { num: [2], name: 'En remodelación' },
      { num: [1], name: 'Remodelado' },
    ],
  };
  if (toString) {
    return values[process.env.GATSBY_COUNTRY].filter(
      (item) =>
        item.num.length === type.length &&
        item.num.every((v, i) => v === type[i])
    )[0].name;
  }

  return values[process.env.GATSBY_COUNTRY].filter(
    (item) => item.name === type
  )[0].num;
};

export default setInventoryType;
